<template>
<div>
    <div class="d-flex justify-center py-6 accent" @click="$router.push('/')" style="cursor:pointer">
        <div>
            <v-img 
                :src="require('@/assets/new-logo.png')"
                width="100px"></v-img>
        </div>
    </div>
    
    <!-- TO DO -->
    <div class="primary--text title font-weight-bold pl-3 mt-6">TO DO</div>
    <div v-for="item in navRoutes.toDo" :key="item.id">
        <div class="primary--text caption font-weight-medium pl-4 mb-1" @click="$router.push(item.path)" style="cursor:pointer" v-if="permission(item)">
            <v-icon size="14" v-text="item.icon" :color="item.color" class="mr-2"></v-icon>
            {{item.title}}
        </div>
    </div>

    <!-- TO LEARN -->
    <div class="primary--text title font-weight-bold pl-3 mt-4">TO LEARN</div>
    <div v-for="item in navRoutes.toLearn" :key="item.id">
        <div class="primary--text caption font-weight-medium pl-4 mb-1" @click="$router.push(item.path)" style="cursor:pointer" v-if="permission(item)">
            <v-icon size="14" v-text="item.icon" :color="item.color" class="mr-2"></v-icon>
            {{item.title}}
        </div>
    </div>

    <!-- PERSONAL -->
    <div class="primary--text title font-weight-bold pl-3 mt-4">PERSONAL</div>
    <div v-for="item in navRoutes.personal" :key="item.id">
        <div class="primary--text caption font-weight-medium pl-4 mb-1" @click="$router.push(item.path)" style="cursor:pointer" v-if="permission(item)">
            <v-icon size="14" v-text="item.icon" :color="item.color" class="mr-2"></v-icon>
            {{item.title}}
        </div>
    </div>

    <!-- ADMIN -->
    <div class="primary--text title font-weight-bold pl-3 mt-4" v-if="user.role.master || user.role.director || user.role.captain">ADMIN</div>
    <div v-for="item in navRoutes.admin" :key="item.id">
        <div class="primary--text caption font-weight-medium pl-4 mb-1" @click="$router.push(item.path)" style="cursor:pointer" v-if="permission(item)">
            <v-icon size="14" v-text="item.icon" :color="item.color" class="mr-2"></v-icon>
            {{item.title}}
        </div>
    </div>

    <!-- <v-list nav dense class="white"> -->
        <!-- <div v-for="item in navRoutes.ground" :key="item.id">
            <v-list-item link :to="item.path" :active-class="getColor(item.color)" light v-if="permission(item)">
                <v-list-item-icon>
                    <v-icon small v-text="item.icon" :class="(item.path!=$route.path) ? item.color+'--text' : 'white--text'"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </div>

        <template v-if="user.role.master || user.role.director || user.role.captain">
            <v-divider color="white" class="mt-4 mb-2" style="opacity:.6"></v-divider>

            <v-subheader class="grey--text text--darken-1 font-weight-medium">ADMIN</v-subheader>

            <div v-for="item in navRoutes.admin" :key="item.id">
                <v-list-item link :to="item.path" :active-class="getColor(item.color)" light v-if="permission(item)">
                    <v-list-item-icon>
                        <v-icon small v-text="item.icon" :class="(item.path!=$route.path) ? item.color+'--text' : 'white--text'"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </div>
        </template>

        <v-divider color="white" class="mt-4 mb-2" style="opacity:.6"></v-divider>

        <v-subheader class="grey--text text--darken-1 font-weight-medium">PERSONAL</v-subheader>

        <div v-for="item in navRoutes.personal" :key="item.id">
            <v-list-item link :to="item.path" :active-class="getColor(item.color)" light>
                <v-list-item-icon>
                    <v-icon small v-text="item.icon" :class="(item.path!=$route.path) ? item.color+'--text' : 'white--text'"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </div> -->
    <!-- </v-list> -->
</div>
</template>

<script>
import NavRoutes from '@/config/navRoutes'

export default {
    data() {
        return {
            navRoutes: NavRoutes,
        }
    },
    methods: {
        permission(item) {
            if (item.allowed == undefined)  return true;

            for (let p in item.allowed) {
                for (let key in this.user.role) {
                    if (p === key) {
                        return true;
                    }
                }
            }
        },
        getColor(color) {
            return 'white--text ' + color;
        },
        signout() {
            this.$store.dispatch('setUser', null);
        }
    }
}
</script>
